import React from 'react';
import divider from 'assets/images/divider.png';
type Props = {};

const Divider = (props: Props) => {
	return <img src={divider} alt='divider' className='w-[300px] object-contain' />;
};

export default Divider;
